import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
        fontFamily: '"Barlow", sans-serif;',
        textTransform: 'initial',
    },
    palette: {
        background: {
            default: '#fbfdff',
        },
        primary: {
            light: '#2996cc',
            main: '#2996cc',
            dark: '#2996cc',
            contrastText: '#ffffff',
        },
        error: {
            light: '#d92169',
            main: '#d92169',
            dark: '#d92169',
            contrastText: '#ffffff',
        },
    },
    shape: {
        borderRadius: 6,
    },
});

function withRoot(Component) {
    function WithRoot(props) {
        // MuiThemeProvider makes the theme available down the React tree
        // thanks to React context.
        return (
            <MuiThemeProvider theme={theme}>
                {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                <CssBaseline />
                <Component {...props} />
            </MuiThemeProvider>
        );
    }

    return WithRoot;
}

export default withRoot;



// WEBPACK FOOTER //
// ./src/styles/withRoot.js